<template>
  <div class="search-container" :class="focus ? 'focused' : 'nfocused'"
       :style="'height:'+height+'; width:'+width+';'"
  >
    <label for="searchinput">
      <feather class="search-icon" type="search" size="16" />
    </label>
    <input
      id="searchinput"
      v-model="searchtext"
      v-debounce:1000="sendData"
      type="search"
      class="search-input"
      placeholder="Pesquisar..."
      @focus="focusinput(true)"
      @blur="focusinput(false)"
    >
  </div>
</template>

<script>
export default {
	props: {
		width: {
			type: String,
			default: '50px',
		},
		height: {
			type: String,
			default: '30px',
		},
	},
	data() {
		return {
			focus: false,
			searchtext: '',
		};
	},
	methods: {
		focusinput(focus) {
			this.focus = focus;
		},
		sendData() {
			this.$emit('searchtext', this.searchtext.toUpperCase());
		},
	},
};
</script>

<style scoped>
.focused {
  background-color: #f4f2ff;
  border: 1px solid #786dce3a;
}
.nfocused {
  background-color: #f4f2ff;
}
.search-container {
  display: flex;
  align-items: center;
  padding: 5px;
  border-radius: 6px;
  transition: 0.3s ease-in;
}
.search-container label {
  all: unset;
  margin: 0;
  display: flex;
  padding: 5px;
}
.search-input {
  all: unset;
  width: 100%;
  height: 100%;
}

.search-input::placeholder{
  font-size: 13px;
}

.search-icon {
  color: #8b83ba;
  padding: 5px;
}
</style>
